// extracted by mini-css-extract-plugin
export default {"tableHeader":"CO2iL2kM0Z9SfOP4j4va"};